import { render, staticRenderFns } from "./Track.vue?vue&type=template&id=3b8bc38d&scoped=true&"
import script from "./Track.vue?vue&type=script&lang=js&"
export * from "./Track.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8bc38d",
  null
  
)

export default component.exports